import { QuoteWizard } from "@/components/QuoteWizard";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Quote() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const preset = params.get("service");
  return (
    <div className="container-x py-14 max-w-3xl">
      <div className="text-center mb-8">
        <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider badge-verified px-3 py-1.5 rounded-full">
          <ShieldCheck className="w-3.5 h-3.5" /> 100% Free for homeowners
        </span>
        <h1 className="font-display text-4xl font-extrabold text-[color:var(--navy)] mt-4">Request Your Free Quote</h1>
        <p className="text-[color:var(--ink-2)] mt-2">Answer a few quick questions and get matched with verified Sacramento pros.</p>
      </div>
      <div className="card-soft p-6 sm:p-10">
        <QuoteWizard presetService={preset} onDone={() => setTimeout(() => nav("/directory"), 4000)} />
      </div>
    </div>
  );
}
